import "regenerator-runtime/runtime";
import * as platformAuth from "@platform/platform-auth";
export const getUserId = platformAuth.getUserId;
export const getBearerToken = platformAuth.getBearerToken;
